var map = {
	"./feature_buy_en.png": "da4c",
	"./feature_buy_id.png": "0613",
	"./feature_buy_my.png": "ed35",
	"./feature_buy_ph.png": "056b",
	"./feature_buy_th.png": "112a",
	"./feature_buy_zh.png": "32f8"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "eb93";